module.exports = __webpack_public_path__ + "static/media/akp-flyer3.1fe34585.png";